import { apiPadron } from "../Utils/RutasApi";
import { trackPromise } from "react-promise-tracker";
import Http from "./Http";
import ParametrosSolicitud from "../Contenedores/Padron/ParametrosSolicitud";
import { __CargarResultadoParametrosSolicitud } from "../Utils/FuncionesSolicitudPadron";
import ResultadoConsultaSolicitud from "../Contenedores/Padron/ResultadoConsultaSolicitud";
import ParametroDetalleSolicitud from "../Contenedores/Padron/ParametroDetalleSolicitud";
import DocumentoSolicitudPadron from "../Contenedores/Padron/DocumentoSolicitudPadron";
import DetalleDeSolicitudPadron from "../Contenedores/Padron/DetalleDeSolicitudPadron";
import ParametroIngresoSolicitud from "../Contenedores/Padron/ParametroIngresoSolicitud";
import { ParametrosActualizaSolicitud } from "../Contenedores/Padron/ParametroActualizaSolicitud";
import { Archivo } from "../Contenedores/Comun/Archivo";

export async function ObtengaParametrosSolicitud(
  parametro: ParametrosSolicitud
) {
  const url = apiPadron.ParametrosSolicitudPadron;
  let consulta = await trackPromise(Http.post<any>(url, parametro));
  let resultado = __CargarResultadoParametrosSolicitud(consulta.data);
  return resultado;
}

async function ObtengaTiposDocumentosSolicitudPadron() {
  const url = apiPadron.ObtengaTiposDocumentosSolicitudesPadron;
  let resultado = await trackPromise(Http.get<any>(url));
  return resultado.data;
}

export async function ConsultaSolicitudesPadron(
  parametro: ParametrosSolicitud
) {
  var resultado = new ResultadoConsultaSolicitud();
  const url = apiPadron.ConsulteSolicitudesPadron;
  let consulta = await trackPromise(Http.post<any>(url, parametro));
  resultado.EsValido = consulta.data.esValido;
  resultado.Errores = consulta.data.errores;
  resultado.Solicitudes = consulta.data.solicitudes;

  return resultado;
}

export async function ObtengaDetalleSolicitudPadron(
  parametro: ParametroDetalleSolicitud
) {
  var resultado = new DetalleDeSolicitudPadron();
  const url = apiPadron.DetalleSolicitudPadron;
  let consulta = await trackPromise(Http.post<any>(url, parametro));
  resultado.EsValido = consulta.data.esValido;
  resultado.Errores = consulta.data.errores;
  resultado.Solicitud = consulta.data;

  return resultado;
}

export async function DocumentoDetalleSolicitudesPadron(
  parametro: DocumentoSolicitudPadron
) {
  var resultado = new DocumentoSolicitudPadron();
  const url = apiPadron.DocumentosDetalleSolicitud;
  let consulta = await trackPromise(Http.post<any>(url, parametro));

  resultado.EsValido = consulta.data.esValido;
  resultado.Errores = consulta.data.errores;
  resultado.Documento = consulta.data.documento;
  resultado.NombreArchivo = consulta.data.nombreArchivo;
  resultado.NumeroSolicitud = consulta.data.numeroSolicitud;
  return resultado;
}

export async function ActualizarSolicitudPadron(
  parametro: ParametrosActualizaSolicitud
) {
  const url = apiPadron.GuardarModificacionSolicitud;
  let resultado = await trackPromise(Http.post<any>(url, parametro));
  return resultado.data;
}

export async function IngresarSolicitudDePadron(
  parametro: ParametroIngresoSolicitud
) {
  const url = apiPadron.IngresoSolicitudDePadron;
  let resultado = await trackPromise(Http.post<any>(url, parametro));

  return resultado.data;
}

export async function ObtengaDatosPasaporte(
  parametro: Archivo
) {
  const url = apiPadron.ObtengaDatosPasaporte;
  let resultado = await trackPromise(Http.post<any>(url, parametro));

  return resultado.data;
}

const SolicitudDePadron = {
  ObtengaParametrosSolicitud,
  ObtengaTiposDocumentosSolicitudPadron,
  ConsultaSolicitudesPadron,
  ObtengaDetalleSolicitudPadron,
  DocumentoDetalleSolicitudesPadron,
  ActualizarSolicitudPadron,
  IngresarSolicitudDePadron,
  ObtengaDatosPasaporte
};

export default SolicitudDePadron;
